module.exports = __webpack_public_path__ + "img/join-us-1.574bd04a.png";